export default __webpack_public_path__ + "static/media/video6.af628532.webp";